/* REFLOW — rétablit position:sticky sans conflit avec Moonbundle.
 * L'app embed Moonbundle (moonbundle-theme-fullstack.js) observe tout le DOM et, à chaque
 * changement (compte à rebours, carrousels, classes au scroll…), pose
 * `overflow: auto !important` sur <html> et <body>. L'ancienne version de ce script
 * retirait aussitôt cette valeur via un MutationObserver : les deux scripts se
 * renvoyaient la balle des centaines de fois par seconde, et sur mobile (iOS surtout)
 * ces bascules d'overflow pendant le défilement font remonter la page.
 * Cette version intercepte l'écriture elle-même : `overflow: auto` n'est jamais posé
 * (aucune mutation, donc aucune boucle). `overflow: hidden` (tiroir panier ouvert) passe
 * normalement, et le passage à `auto` à la fermeture retire simplement le verrou.
 */
(function () {
  var targets = [document.documentElement, document.body];

  targets.forEach(function (el) {
    if (!el || !el.style || el.style.__rfPatched) return;
    var st = el.style;
    var originalSetProperty = st.setProperty;

    st.setProperty = function (prop, value, priority) {
      if (String(prop).toLowerCase() === 'overflow' && String(value).trim().toLowerCase() === 'auto') {
        if (st.getPropertyValue('overflow')) st.removeProperty('overflow');
        return;
      }
      return originalSetProperty.call(st, prop, value, priority);
    };
    st.__rfPatched = true;

    // Nettoyage unique si Moonbundle est passé avant ce script.
    if (st.getPropertyValue('overflow') === 'auto') st.removeProperty('overflow');
  });
})();
/* REFLOW — clic sur le badge d'avis : défilement fluide vers les avis. */
(function () {
  function reviewsTarget() {
    return document.querySelector('.trustap-full-review');
  }
  function markBadges() {
    if (!reviewsTarget()) return;
    document.querySelectorAll('.reviews-badge').forEach(function (badge) {
      if (!badge.querySelector('a')) badge.style.cursor = 'pointer';
    });
  }
  document.addEventListener('click', function (e) {
    var badge = e.target.closest && e.target.closest('.reviews-badge');
    if (!badge || badge.querySelector('a')) return;
    var target = reviewsTarget();
    if (!target) return;
    e.preventDefault();
    target.style.scrollMarginTop = '20px';
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  document.addEventListener('DOMContentLoaded', markBadges);
  window.addEventListener('load', markBadges);
})();